module.exports = __webpack_public_path__ + "img/children-playing.71251e1d.png";